import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a27793538ca120014016d79_1784121683251_6ed14a77/docalert/src/app/sign-up-login-screen/components/AuthScreen.tsx");
